import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/cars',
  component: LAYOUT,
  name: 'Cars',
  redirect: '/cars/configure',
  meta: {
    title: '车辆配置',
  },
  children: [
    {
      path: 'configure',
      name: 'CarsConfigure',
      meta: {
        title: '车辆配置',
        keepAlive: true,
      },
      component: () => import('@/views/cars/configure/index'),
    },
    {
      path: 'preview',
      name: 'CarsConfigurePreview',
      meta: {
        title: '配置预览',
        keepAlive: true,
      },
      component: () => import('@/views/cars/preview/index'),
    },
    {
      path: 'orderInfo',
      name: 'CarsOrderInfo',
      meta: {
        title: '订单信息',
        keepAlive: true,
      },
      component: () => import('@/views/cars/orderInfo/index'),
    },
    {
      path: 'orderConfirm',
      name: 'CarsOrderConfirm',
      meta: {
        title: '订单确认',
        keepAlive: true,
      },
      component: () => import('@/views/cars/orderConfirm/index'),
    },
    {
      path: 'dealer',
      name: 'CarsDealer',
      meta: {
        title: '选择经销商',
        keepAlive: true,
      },
      component: () => import('@/views/cars/dealer/index'),
    },
    {
      path: 'equityDesc',
      name: 'CarsEquityDesc',
      meta: {
        title: '权益说明',
      },
      component: () => import('@/views/cars/equityDesc/index'),
    },
    {
      path: 'payResult',
      name: 'CarsPayResult',
      meta: {
        title: '收银台', // 支付结果
      },
      component: () => import('@/views/cars/payResult/index'),
    },
    {
      path: 'orders',
      name: 'CarsOrders',
      meta: {
        title: '我的预订',
      },
      component: () => import('@/views/cars/orders/index'),
    },
    {
      path: 'ordersDetail',
      name: 'CarsOrdersDetail',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/cars/ordersDetail/index'),
    },
    {
      path: 'activityDetail',
      name: 'ActivityDetail',
      meta: {
        title: '活动详情',
        keepAlive: true,
      },
      component: () => import('@/views/cars/activityDetail/index'),
    },
    {
      path: 'buyCarRights',
      name: 'buyCarRights',
      meta: {
        title: '车型亮点', // 购车权益
        keepAlive: true,
      },
      component: () => import('@/views/cars/buyCarRights/index'),
    },
    {
      path: 'paramConfig',
      name: 'paramConfig',
      meta: {
        title: '参数配置',
        keepAlive: true,
      },
      component: () => import('@/views/cars/paramConfig/index'),
    },
  ],
};
